// extracted by mini-css-extract-plugin
export var actionIcon = "_qb-0";